import React from "react";

const DashboardIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 19 17.6463"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5874,0h7.8343c0.2592,0 0.4704,0.211 0.4704,0.47v7.163c0,0.259 -0.2112,0.47 -0.4704,0.47h-9.9513c-0.2592,0 -0.4704,-0.211 -0.4704,-0.47v-5.046c0,-1.43 1.1617,-2.587 2.5874,-2.587z"
        fill="#1A8B5A"
      />
      <path
        d="M16.4126,1.2c0.7632,0 1.3873,0.624 1.3873,1.387v4.316h-4.2676v-5.708h2.8755M16.4126,0h-3.6051c-0.2592,0 -0.4705,0.211 -0.4705,0.47v7.163c0,0.259 0.2113,0.47 0.4705,0.47h5.7221c0.2592,0 0.4704,-0.211 0.4704,-0.47v-5.046c0,-1.43 -1.1569,-2.587 -2.5874,-2.587z"
        fill="currentColor"
      />
      <path
        d="M17.8003,10.743v4.316c0,0.763 -0.624,1.387 -1.3873,1.387h-7.1094v-5.708h8.4967M18.5252,9.543h-9.9512c-0.2593,0 -0.4705,0.211 -0.4705,0.47v7.163c0,0.259 0.2112,0.47 0.4705,0.47h7.8342c1.4305,0 2.5874,-1.157 2.5874,-2.587v-5.046c0,-0.259 -0.2112,-0.47 -0.4704,-0.47z"
        fill="currentColor"
      />
      <path
        d="M5.4629,10.743v5.708h-2.8755c-0.7632,0 -1.3873,-0.624 -1.3873,-1.387v-4.316h4.2676M6.1925,9.543h-5.7221c-0.2592,0 -0.4704,0.211 -0.4704,0.471v5.045c0,1.43 1.1569,2.587 2.5874,2.587h3.6051c0.2592,0 0.4705,-0.211 0.4705,-0.47v-7.162c0,-0.26 -0.2113,-0.471 -0.4705,-0.471z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DashboardIcon;
